// src/admin/components/AnalyticsLineChart.jsx

import {
    ResponsiveContainer,
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
} from "recharts";

import { useTheme } from "../../context/ThemeContext";

export default function AnalyticsLineChart({

    title,

    description,

    data = [],

    xKey,

    lines = [],

}) {

    const { isDark } = useTheme();

    return (

        <section
            className={`
                rounded-3xl
                border
                p-8
                ${
                    isDark
                        ? "bg-white/5 border-white/10"
                        : "bg-white border-gray-200"
                }
            `}
        >

            <div className="mb-8">

                <h2 className="text-xl font-semibold">

                    {title}

                </h2>

                {description && (

                    <p className="mt-2 text-sm opacity-70">

                        {description}

                    </p>

                )}

            </div>

            <ResponsiveContainer
                width="100%"
                height={350}
            >

                <LineChart data={data}>

                    <CartesianGrid strokeDasharray="3 3" />

                    <XAxis dataKey={xKey} />

                    <YAxis />

                    <Tooltip />

                    <Legend />

                    {lines.map(line => (

                        <Line
                            key={line.dataKey}
                            type="monotone"
                            dataKey={line.dataKey}
                            stroke={line.color}
                            strokeWidth={3}
                            name={line.name}
                        />

                    ))}

                </LineChart>

            </ResponsiveContainer>

        </section>

    );

}